// document.addEventListener("DOMContentLoaded", function () {
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");
//   let activeMenuItem = null;

//   menuItems.forEach((item) => {
//     const detailsElement = item.querySelector("details");
//     if (!detailsElement) return;

//     item.addEventListener("mouseenter", () => {
//       if (activeMenuItem && activeMenuItem !== item) {
//         const previousDetailsElement = activeMenuItem.querySelector("details");
//         if (previousDetailsElement) {
//           previousDetailsElement.removeAttribute("open");
//         }
//       }
//       detailsElement.setAttribute("open", true);
//       activeMenuItem = item;
//     });

//     item.addEventListener("mouseleave", () => {
//       setTimeout(() => {
//         if (!item.matches(":hover")) {
//           detailsElement.removeAttribute("open");
//           if (activeMenuItem === item) activeMenuItem = null;
//         }
//       },500); // Adjust delay as needed
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");
  let activeMenuItem = null;

  menuItems.forEach((item) => {
    const detailsElement = item.querySelector("details");
    if (!detailsElement) return;

    // ENTRADA
    item.addEventListener("mouseenter", () => {
      // Se havia outro item fechando, reseta ele imediatamente
      if (activeMenuItem && activeMenuItem !== item) {
         const prevDetails = activeMenuItem.querySelector("details");
         activeMenuItem.classList.remove("is-closing"); // Remove animação de saída
         if(prevDetails) prevDetails.removeAttribute("open"); // Fecha forçado
      }
      
      activeMenuItem = item;
      item.classList.remove("is-closing"); // Garante que não está fechando
      detailsElement.setAttribute("open", true);
    });

    // SAÍDA
    item.addEventListener("mouseleave", () => {
      // 1. Adiciona classe para o CSS iniciar o fade-out
      
      // 2. Espera o tempo da animação (500ms)
      item.classList.add("is-closing");
      setTimeout(() => {
        // Verifica se o usuário NÃO voltou com o mouse (se a classe ainda existe)
        if (item.classList.contains("is-closing")) {
          detailsElement.removeAttribute("open");
          item.classList.remove("is-closing");
          if (activeMenuItem === item) activeMenuItem = null;
        }
      }, 500); 
    });
  });
});